import React from 'react';

const TableTabs = ({ activeTable, setActiveTable }) => {
    return (
        <div className="flex gap-3">
            <button
                onClick={() => setActiveTable("Website")}
                className={`transition-all duration-300 px-5 py-2 rounded-lg font-medium shadow-md ${
                    activeTable === "Website"
                        ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white"
                        : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                }`}
            >
                Website
            </button>
            <button
                onClick={() => setActiveTable("App")}
                className={`transition-all duration-300 px-5 py-2 rounded-lg font-medium shadow-md ${
                    activeTable === "App"
                        ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white"
                        : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                }`}
            >
                App
            </button>
        </div>
    );
};

export default TableTabs;